import { render, staticRenderFns } from "./Anmeldungsliste.vue?vue&type=template&id=0ad5e205"
import script from "./Anmeldungsliste.vue?vue&type=script&lang=js"
export * from "./Anmeldungsliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports